import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/shared/api/apiClient'

const QUERY_KEY = 'audit-logs'

export type AuditLog = {
  eventType: string
  resourceName: string
  resourceId: string
  metadata: Record<string, string>
  createdAt: string
  user: {
    id: string
    firstName: string
    lastName: string
    email: string
  }
}

export const useOrganizationAuditLogs = (organizationId: string) => {
  return useQuery<AuditLog[]>({
    queryKey: [QUERY_KEY],
    queryFn: async () => {
      const res = await apiClient.get(`/v1/organizations/${organizationId}/audit-logs`)
      return res.data
    }
  })
}
